export const translations = {
  en: {
    common: {
      bookNow: 'Book Now',
      close: 'Close',
      enquireNow: 'Enquire Now',
      backToHome: 'Back to Home'
    },
    header: {
      whatsapp: 'WhatsApp',
      helpline: 'Helpline',
      login: 'Login / Signup',
      dashboard: 'Dashboard',
      logout: 'Logout',
    },
    hero: {
      title: 'Experience Divine Blessings',
      subtitle: 'Your trusted partner for seamless temple services.',
      searchPlaceholder: 'Search Temple Name or City...',
    },
    quickActions: {
      darshan: 'Book Darshan Tickets',
      epuja: 'Book E-Puja',
      prasad: 'Prasad Subscription',
      queue: 'Queue Assistance',
      tours: 'Temple Tours & Transport',
      seva: 'Special Seva Booking',
    },
    featuredTemples: {
      title: 'Featured Temples',
      seeAll: 'See All Temples',
    },
    templeCard: {
      deity: 'Deity',
      famousPuja: 'Famous Puja',
      viewServices: 'View Services',
    },
    services: {
      title: 'Our Core Services',
      subtitle: 'Making your spiritual journey simple and accessible.',
      darshan: {
        title: 'Darshan Queue Service',
        description: 'We stand in queue for you & arrange priority access.',
      },
      epuja: {
        title: 'E-Puja & Offerings',
        description: 'We perform rituals on your behalf with live streaming.',
      },
      prasad: {
        title: 'Prasad Subscription',
        description: 'Receive temple prasad at your home every month.',
      },
    },
    testimonials: {
      title: 'Words from Devotees',
    },
    trustBadges: {
      devotees: 'Trusted by 1,00,000+ Devotees',
      payments: '100% Secure Payments',
      verified: 'Temple Verified Services',
    },
    howItWorks: {
      title: 'How It Works in 3 Simple Steps',
      subtitle: 'Book your divine experience effortlessly.',
      step1: {
        title: 'Choose Temple & Service',
        description: 'Browse our list of temples and select the puja or service you desire.',
      },
      step2: {
        title: 'Confirm & Pay Online',
        description: 'Provide necessary details and complete the payment through our secure gateway.',
      },
      step3: {
        title: 'Receive Updates',
        description: 'Get confirmation and updates for your darshan, prasad, or puja on your phone.',
      },
    },
    footer: {
      about: 'Connecting devotees with temples across India, we strive to make spiritual experiences accessible to all.',
      quickLinks: 'Quick Links',
      aboutUs: 'About Us',
      contactUs: 'Contact Us',
      faq: 'FAQ',
      privacy: 'Privacy Policy',
      refund: 'Refund Policy',
      weAccept: 'We Accept',
      followUs: 'Follow Us',
      followUsText: 'For festival updates and more!',
      copyright: 'All Rights Reserved.',
    },
    templeDetail: {
        requirements: 'Requirements',
        back: 'Back to All Temples',
        mainDeity: 'Main Deity',
        famousPuja: 'Most Famous Puja',
        atAGlance: 'Temple at a Glance',
        epujaTitle: 'E-Puja Live from Temple',
        inPersonPujasTitle: 'In-Person Pujas & Services',
        bookEPuja: 'Book E-Puja',
        bookPujaCta: 'Book a Puja',
        nav: {
          about: 'About',
          packages: 'Packages',
          howItWorks: 'How it Works',
          benefits: 'Benefits',
          reviews: 'Reviews',
          faq: 'FAQ',
        },
        sections: {
          about: 'About the Temple',
          packages: 'Available Pujas & Services',
          howItWorks: 'How Our Service Works',
          benefits: 'Spiritual Benefits',
          reviews: 'Devotee Reviews',
          faq: 'Frequently Asked Questions',
        }
    },
    loginModal: {
      title: 'Login to astrologica',
      subtitle: 'Enter your credentials to access your dashboard.',
      emailLabel: 'Email Address',
      emailOrMobileLabel: 'Email or Mobile Number',
      emailOrMobilePlaceholder: 'your@email.com or 9876543210',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Choose a strong password',
      loginButton: 'Login',
      invalidCredentials: 'Invalid credentials. Please try again.',
      demoInfo: 'Use admin@divine.com (admin), user@divine.com (user), or manager@divine.com (manager). Pass: admin123 / user123 / manager123',
      signupTitle: 'Create an Account',
      signupSubtitle: 'Join astrologica to start your spiritual journey.',
      nameLabel: 'Full Name',
      mobileLabel: 'Mobile Number',
      signupButton: 'Sign Up',
      switchToSignupPrompt: "Don't have an account?",
      switchToSignupLink: 'Sign Up',
      switchToLoginPrompt: 'Already have an account?',
      switchToLoginLink: 'Log In',
      forgotPassword: 'Forgot Password?',
      forgotPasswordTitle: 'Reset Your Password',
      forgotPasswordSubtitle: "Enter your email and we'll send you a link to reset your password.",
      sendResetLinkButton: 'Send Reset Link',
      backToLogin: 'Back to Login',
      resetLinkSentTitle: 'Check Your Email',
      resetLinkSentMessage: 'If an account exists for {{email}}, you will receive an email with instructions on how to reset your password.',
      error: {
        userExists: 'A user with this mobile number already exists.',
        generic: 'An unexpected error occurred. Please try again.',
      },
      aria: {
        close: 'Close login modal',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
      }
    },
    bookingModal: {
        title: 'Book Puja',
        subtitle: 'Fill in the details below to confirm your slot.',
        labels: {
            date: 'Select Date',
            timeSlot: 'Time Slot',
            devotees: 'Number of Devotees',
            fullName: 'Full Name',
            phone: 'Phone Number (for updates)',
            puja: 'Puja',
            transactionId: 'Transaction ID',
        },
        timeSlots: {
            morning: 'Morning (8am - 12pm)',
            afternoon: 'Afternoon (1pm - 5pm)',
            evening: 'Evening (6pm - 9pm)',
        },
        placeholders: {
            fullName: 'Enter your full name',
            phone: 'Enter your 10-digit mobile number',
        },
        total: 'Total Amount',
        buttons: {
            processing: 'Processing...',
            confirmRazorpay: 'Pay via Card/Netbanking',
            confirmPhonePe: 'Pay via UPI (PhonePe)',
            viewInDashboard: 'View in Dashboard',
        },
        success: {
            title: 'Booking Confirmed!',
            message: 'Your puja has been successfully booked. A confirmation has been sent to your phone.',
            epujaMessage: 'Your E-Puja has been successfully booked. The live stream link will be provided via email and on your dashboard shortly before the scheduled time.',
        },
        aria: {
            closeForm: 'Close booking form',
        }
    },
    dashboard: {
        title: 'My Dashboard',
        welcome: 'Welcome back, {{name}}!',
        streamLinkPending: 'Stream link will be available soon',
        buttons: {
            logout: 'Logout',
            viewDetails: 'View Details',
            viewStream: 'View Live Stream',
            renew: 'Renew',
            cancel: 'Cancel',
            editProfile: 'Edit Profile',
        },
        bookings: {
            title: 'My Bookings',
            upcoming: 'Upcoming',
            past: 'Past Bookings',
            none: {
                line1: 'You have no upcoming bookings.',
                line2: 'Book a puja to see it here.',
                cta: 'Explore Temples',
            },
        },
        profile: {
            title: 'Profile Settings',
            name: 'Full Name',
            phone: 'Phone Number',
            email: 'Email Address',
        },
        subscriptions: {
            title: 'Prasad Subscriptions',
            frequency: 'Frequency',
            monthly: 'Monthly',
            quarterly: 'Quarterly',
            nextDelivery: 'Next Delivery',
            confirmCancel: 'Are you sure you want to cancel your {{prasadName}} subscription from {{templeName}}?',
            cancelSuccess: 'Your subscription has been cancelled.',
        },
        statuses: {
            confirmed: 'Confirmed',
            completed: 'Completed',
        },
        streamTitle: 'Live Stream Player',
        details: {
            devoteeInfo: 'Devotee Information',
            bookingInfo: 'Booking & Payment Details',
            devoteesCount: '{{count}} Devotee(s)',
            date: 'Date',
            status: 'Status',
            price: 'Total Price',
            transactionId: 'Transaction ID',
        },
        aria: {
            closeStream: 'Close live stream',
            closeDetails: 'Close booking details',
        }
    },
    adminDashboard: {
        title: 'Administrator Dashboard',
        welcome: 'Welcome, Admin!',
        searchPlaceholder: 'Search users, temples, bookings…',
        stats: {
            totalBookings: 'Total Bookings',
            revenueToday: 'Revenue Today',
            totalRevenue: 'Total Revenue',
            activeSubscriptions: 'Active Subscriptions',
            pendingRefunds: 'Pending Refunds',
        },
        menu: {
            dashboard: 'Dashboard',
            temples: 'Temples Management',
            services: 'Services Management',
            bookings: 'Bookings Management',
            users: 'Users Management',
            payments: 'Payments',
            reports: 'Reports',
            content: 'Content & CMS',
            settings: 'Settings',
            queueAssistance: 'Queue Assistance',
            prasadSubscriptions: 'Prasad Subscriptions',
            templeTours: 'Temple Tours',
        },
        profile: {
            settings: 'Settings',
            logout: 'Logout',
        },
        bookings: {
            title: 'All User Bookings',
            user: 'User',
            puja: 'Puja / Temple',
            date: 'Date',
            amount: 'Amount',
            status: 'Status',
            actions: 'Actions',
            bookingId: 'Booking ID',
            filterByStatus: 'Filter by status',
            allStatuses: 'All Statuses',
            statusCancelled: 'Cancelled',
            searchPlaceholder: 'Search by ID, user, or temple...'
        },
        prasadSubscriptions: {
          title: 'Prasad Subscriptions Management',
          searchPlaceholder: 'Search by user, temple, or prasad...',
          allStatuses: 'All Statuses',
          statusActive: 'Active',
          statusCancelled: 'Cancelled',
          confirmCancel: 'Confirm Subscription Cancellation',
          confirmCancelMessage: "Are you sure you want to cancel the '{{prasadName}}' subscription for {{userName}}?",
          cancelSuccess: 'Subscription cancelled successfully.',
          detailsTitle: 'Subscription Details',
          deliveryAddress: 'Delivery Address',
          subscriptionId: 'Subscription ID',
          paymentTransactionId: 'Payment Transaction ID (PRN)',
          subscribedOn: 'Subscribed On',
          table: {
            user: 'User',
            subscription: 'Subscription',
            details: 'Details',
            nextDelivery: 'Next Delivery',
            status: 'Status',
            actions: 'Actions',
          }
        },
        queueAssistance: {
            title: 'Queue Assistance Bookings',
            package: 'Package',
            addOns: 'Add-ons',
            detailsTitle: 'Queue Assistance Details',
            tabs: {
              bookings: 'Bookings',
              packages: 'Package Management',
              addons: 'Add-on Management'
            },
            packages: {
                title: 'Assistance Packages',
                addNew: 'Add New Package',
                edit: 'Edit Package',
                confirmDelete: 'Are you sure you want to delete this package?',
                form: {
                    name: 'Package Name',
                    description: 'Description',
                    price: 'Price (INR)',
                    order: 'Display Order',
                    active: 'Active'
                }
            },
            addons: {
                title: 'Personal Assistance Add-ons',
                addNew: 'Add New Add-on',
                edit: 'Edit Add-on',
                confirmDelete: 'Are you sure you want to delete this add-on?',
                form: {
                    name: 'Add-on Name',
                    description: 'Description',
                    price: 'Price (INR)',
                    type: 'Add-on Type',
                    active: 'Active'
                },
                types: {
                    guide: 'Local Guide',
                    pickup: 'Pickup & Drop',
                    poojaItems: 'Pooja Items Kit'
                }
            },
            table: {
                name: 'Name',
                description: 'Description',
                price: 'Price',
                status: 'Status',
                active: 'Active',
                inactive: 'Inactive',
                actions: 'Actions'
            }
        },
        payments: {
            title: 'All Transactions',
            table: {
                transactionId: 'Transaction ID',
                user: 'User',
                paymentFor: 'For Service',
                date: 'Payment Date',
                amount: 'Amount',
                status: 'Status',
                actions: 'Actions',
            }
        },
        reports: {
            title: 'Analytics & Reports',
            subtitle: 'Insights into platform performance.',
            totalRevenue: 'Total Revenue',
            averageBookingValue: 'Average Booking Value',
            monthlyPerformance: 'Monthly Performance',
            chartBookings: 'Bookings',
            chartRevenue: 'Revenue',
        },
        temples: {
            title: 'Temples Management',
            addNew: 'Add New Temple',
            editTemple: 'Edit Temple',
            confirmDelete: 'Are you sure you want to delete this temple? This action cannot be undone.',
            confirmDeleteFaq: 'Are you sure you want to delete this FAQ?',
            table: {
                image: 'Image',
                name: 'Temple Name',
                location: 'Location',
                deity: 'Deity',
                actions: 'Actions'
            },
            form: {
                id: 'Temple ID',
                nameKey: 'Name Key',
                locationKey: 'Location Key',
                deityKey: 'Deity Key',
                imageUrl: 'Image URL',
                descriptionKey: 'Description Key',
                famousPujaKey: 'Famous Puja Key',
                faqsTitle: 'Frequently Asked Questions',
                questionKey: 'Question Key',
                answerKey: 'Answer Key',
                benefitsTitle: 'Spiritual Benefits',
                benefitKey: 'Benefit Key',
                pujasTitle: 'Available Pujas & Services',
                pujaNameKey: 'Puja Name Key',
                pujaDescriptionKey: 'Puja Description Key',
                price: 'Price (INR)',
                isEPuja: 'Is E-Puja?',
                ePujaDetailsKey: 'E-Puja Details Key',
                virtualTourLink: 'Virtual Tour Link (Embed URL)',
                requirementsKey: 'Puja Requirements Key',
                prasadsTitle: 'Available Prasad for Subscription',
                prasadNameKey: 'Prasad Name Key',
                prasadDescriptionKey: 'Prasad Description Key',
                prasadImageUrl: 'Prasad Image URL',
                priceMonthly: 'Monthly Price (INR)',
                priceQuarterly: 'Quarterly Price (INR)',
            },
            buttons: {
                edit: 'Edit',
                delete: 'Delete',
                save: 'Save Changes',
                cancel: 'Cancel',
                addFaq: 'Add FAQ',
                addBenefit: 'Add Benefit',
                addPuja: 'Add Puja',
                addPrasad: 'Add Prasad',
            }
        },
        tours: {
            title: 'Temple Tours Management',
            addNew: 'Add New Tour',
            editTour: 'Edit Tour Package',
            confirmDelete: 'Are you sure you want to delete this tour package?',
            table: {
                name: 'Tour Name',
                duration: 'Duration',
                price: 'Price',
                actions: 'Actions',
            },
            form: {
                nameKey: 'Name Key',
                descriptionKey: 'Description Key',
                imageUrl: 'Image URL',
                price: 'Price (INR)',
                durationKey: 'Duration Key',
            }
        },
        users: {
            title: 'Users Management',
            addNew: 'Add New User',
            editUser: 'Edit User',
            confirmDelete: 'Are you sure you want to delete this user? This may affect their existing bookings.',
            table: {
                name: 'Name',
                email: 'Email / Mobile',
                role: 'Role',
                actions: 'Actions'
            },
            form: {
                name: 'Full Name',
                email: 'Email Address',
                mobile: 'Mobile Number',
                password: 'Password',
                passwordHint: 'Leave blank to keep current password',
                role: 'User Role',
                assignedTemple: 'Assigned Temple (for Managers)',
                selectTemple: 'Select a temple'
            },
            roles: {
                user: 'User',
                admin: 'Admin',
                temple_manager: 'Temple Manager'
            }
        },
        content: {
            seasonalEvent: {
                title: 'Seasonal Event Banner',
                formTitle: 'Title',
                formDescription: 'Description',
                formCta: 'CTA Button Text',
                formImageUrl: 'Background Image URL',
                saveSuccess: 'Seasonal event banner updated successfully!'
            },
            testimonials: {
                title: 'Testimonials Management',
                addNew: 'Add New Testimonial',
                edit: 'Edit Testimonial',
                confirmDelete: 'Are you sure you want to delete this testimonial?',
                table: {
                    quote: 'Quote',
                    author: 'Author',
                    actions: 'Actions'
                },
                form: {
                    quote: 'Quote',
                    author: 'Author',
                    location: 'Location'
                }
            }
        },
        settings: {
            title: 'Application Settings',
            form: {
                contactInfo: 'Contact Information',
                helpline: 'Helpline Number',
                whatsapp: 'WhatsApp Number',
                email: 'Contact Email',
            },
            buttons: {
                save: 'Save Changes'
            },
            saveSuccess: 'Settings updated successfully!'
        },
        services: {
            title: 'Services Management',
            addNew: 'Add New Service',
            editService: 'Edit Service',
            confirmDelete: 'Are you sure you want to delete this service?',
            table: {
                title: 'Service Title',
                description: 'Description',
                icon: 'Icon',
                actions: 'Actions',
            },
            form: {
                titleKey: 'Title Key',
                descriptionKey: 'Description Key',
                icon: 'Icon Name',
                iconHint: 'e.g., Users, Sparkles, Gift (from lucide-react)',
            },
        },
    },
    templeListPage: {
        titleAll: 'Book Darshan at any Temple',
        titleEPuja: 'Temples Offering E-Puja',
        subtitle: 'Select a temple to view available services and book your visit.',
        back: 'Back to Home'
    },
    prasadSubscriptionPage: {
        title: 'Prasad Subscription Service',
        subtitle: 'Get blessed prasad from your favorite temples delivered to your home.',
        back: 'Back to Home',
        subscribeNow: 'Subscribe Now',
        monthly: 'Monthly',
        quarterly: 'Quarterly',
        monthlyPrice: '₹{{price}}/month',
        quarterlyPrice: '₹{{price}}/quarter'
    },
    subscriptionModal: {
        title: 'Subscribe to Prasad',
        subtitle: 'Confirm your details to start your subscription.',
        labels: {
            frequency: 'Subscription Frequency',
            fullName: 'Full Name',
            phone: 'Phone Number',
            address: 'Delivery Address',
        },
        placeholders: {
            fullName: 'Enter your full name',
            phone: 'Enter your 10-digit mobile number',
            address: 'Enter your full delivery address'
        },
        total: 'Amount Payable',
        buttons: {
            confirmRazorpay: 'Pay via Card/Netbanking',
            confirmPhonePe: 'Pay via UPI (PhonePe)',
            viewInDashboard: 'View in Dashboard',
        },
        success: {
            title: 'Subscription Activated!',
            message: 'Your prasad subscription has been successfully started. Your first delivery is on its way!',
        },
        aria: {
            close: 'Close subscription form'
        }
    },
    paymentStatus: {
      verifying: 'Verifying your payment...',
      pleaseWait: 'Please wait, do not close this window.',
      successTitle: 'Payment Successful!',
      successMessageBooking: 'Your booking has been confirmed. You can view the details in your dashboard.',
      successMessageSubscription: 'Your subscription is now active. You can manage it from your dashboard.',
      failedTitle: 'Payment Failed',
      failedMessage: 'Unfortunately, your payment could not be processed. Please try again.',
      tryAgain: 'Try Again',
      goToDashboard: 'Go to Dashboard',
    },
    comingSoon: {
      title: 'Feature Coming Soon!',
      description: 'We are working hard to bring this feature to you. Please check back later for updates.',
      cta: 'Explore Other Services'
    },
    queueAssistancePage: {
      title: 'Queue Assistance Service',
      description: 'Avoid long waiting times. Our assistants will stand in the queue on your behalf, allowing you to have a swift and peaceful darshan.',
      formTitle: 'Book Your Slot',
      pricePerPerson: '₹{{price}} per person',
      selectTemple: 'Select a Temple',
      labels: {
        assistanceType: 'Choose Assistance Package',
        timeSlot: 'Preferred Time Slot',
      },
      packages: {
        normal: {
          name: 'Normal Queue Assistance',
          description: 'Our assistant will stand in the general queue for you.'
        },
        senior: {
          name: 'Senior Citizen / Special Assistance',
          description: 'Includes wheelchair support and priority arrangements where available.'
        },
        vip: {
          name: 'VIP Darshan Facilitation',
          description: 'We arrange for express/VIP entry passes for the quickest darshan.'
        }
      },
      addons: {
        title: 'Personal Assistance Add-ons',
        price: '+ ₹{{price}}',
        guide: {
            label: 'Local Guide Service',
            description: 'An experienced guide for your temple visit.',
            language: 'Preferred Language'
        },
        pickup: {
            label: 'Pickup & Drop Service',
            description: 'Hassle-free transport from your hotel/location.'
        },
        poojaItems: {
            label: 'Pooja Items Kit',
            description: 'Includes flowers, prasad, and other essentials.'
        }
      },
      languages: {
          english: 'English',
          hindi: 'Hindi',
          tamil: 'Tamil',
          telugu: 'Telugu'
      },
      liveStatus: {
        title: 'Live Queue Status',
        approxTime: 'Approx. {{time}} mins',
        devoteesInQueue: '{{count}} devotees in queue',
        lastUpdated: 'Last updated at {{time}}',
        selectTemplePrompt: 'Select a temple to view live status.',
        noData: 'Live status currently unavailable for this temple.'
      },
      notifications: {
        label: 'Receive SMS/WhatsApp alerts when your turn is near.'
      },
      map: {
        title: 'Temple Layout & Guidance'
      }
    },
    templeToursPage: {
      title: 'Curated Temple Tours',
      subtitle: 'Explore the spiritual heritage of India with our all-inclusive tour packages.',
      priceStartingFrom: 'Starting from ₹{{price}}'
    },
    specialSevaPage: {
      title: 'Book a Special Seva',
      subtitle: 'Participate in exclusive rituals for your family\'s well-being and prosperity.',
      benefits: 'Spiritual Benefits'
    },
    data: {
      tours: {
        goldenTriangle: {
            name: 'Spiritual Golden Triangle Tour',
            description: 'Visit the most sacred temples in Delhi, Agra, and Jaipur. A journey of faith and history.'
        },
        charDham: {
            name: 'Himalayan Char Dham Yatra',
            description: 'A holy pilgrimage to the four abodes of Yamunotri, Gangotri, Kedarnath, and Badrinath.'
        },
        durations: {
            '5d4n': '5 Days / 4 Nights',
            '10d9n': '10 Days / 9 Nights'
        }
      }
    }
  },
  hi: {
    common: {
      bookNow: 'अभी बुक करें',
      close: 'बंद करें',
      enquireNow: 'अभी पूछताछ करें',
      backToHome: 'होम पर वापस जाएं'
    },
    header: {
      whatsapp: 'व्हाट्सएप',
      helpline: 'हेल्पलाइन',
      login: 'लॉगिन / साइनअप',
      dashboard: 'डैशबोर्ड',
      logout: 'लॉगआउट',
    },
    hero: {
      title: 'दिव्य आशीर्वाद का अनुभव करें',
      subtitle: 'निर्बाध मंदिर सेवाओं के लिए आपका विश्वसनीय साथी।',
      searchPlaceholder: 'मंदिर का नाम या शहर खोजें...',
    },
    quickActions: {
      darshan: 'दर्शन टिकट बुक करें',
      epuja: 'ई-पूजा बुक करें',
      prasad: 'प्रसाद सदस्यता',
      queue: 'कतार सहायता',
      tours: 'मंदिर टूर और परिवहन',
      seva: 'विशेष सेवा बुकिंग',
    },
    featuredTemples: {
      title: 'विशेष मंदिर',
      seeAll: 'सभी मंदिर देखें',
    },
    templeCard: {
      deity: 'देवता',
      famousPuja: 'प्रसिद्ध पूजा',
      viewServices: 'सेवाएं देखें',
    },
    services: {
      title: 'हमारी मुख्य सेवाएं',
      subtitle: 'आपकी आध्यात्मिक यात्रा को सरल और सुलभ बनाना।',
      darshan: {
        title: 'दर्शन कतार सेवा',
        description: 'हम आपके लिए कतार में खड़े रहते हैं और प्राथमिकता पहुंच की व्यवस्था करते हैं।',
      },
      epuja: {
        title: 'ई-पूजा और प्रसाद',
        description: 'हम आपकी ओर से लाइव स्ट्रीमिंग के साथ अनुष्ठान करते हैं।',
      },
      prasad: {
        title: 'प्रसाद सदस्यता',
        description: 'हर महीने अपने घर पर मंदिर का प्रसाद प्राप्त करें।',
      },
    },
    testimonials: {
      title: 'भक्तों के शब्द',
    },
    trustBadges: {
      devotees: '1,00,000+ भक्तों द्वारा विश्वसनीय',
      payments: '100% सुरक्षित भुगतान',
      verified: 'मंदिर सत्यापित सेवाएं',
    },
    howItWorks: {
      title: '3 सरल चरणों में यह कैसे काम करता है',
      subtitle: 'अपने दिव्य अनुभव को सहजता से बुक करें।',
      step1: {
        title: 'मंदिर और सेवा चुनें',
        description: 'हमारे मंदिरों की सूची ब्राउज़ करें और अपनी इच्छित पूजा या सेवा का चयन करें।',
      },
      step2: {
        title: 'पुष्टि करें और ऑनलाइन भुगतान करें',
        description: 'आवश्यक विवरण प्रदान करें और हमारे सुरक्षित गेटवे के माध्यम से भुगतान पूरा करें।',
      },
      step3: {
        title: 'अपडेट प्राप्त करें',
        description: 'अपने दर्शन, प्रसाद, या पूजा के लिए अपने फोन पर पुष्टि और अपडेट प्राप्त करें।',
      },
    },
    footer: {
      about: 'पूरे भारत में भक्तों को मंदिरों से जोड़ते हुए, हम आध्यात्मिक अनुभवों को सभी के लिए सुलभ बनाने का प्रयास करते हैं।',
      quickLinks: 'त्वरित लिंक',
      aboutUs: 'हमारे बारे में',
      contactUs: 'हमसे संपर्क करें',
      faq: 'FAQ',
      privacy: 'गोपनीयता नीति',
      refund: 'धनवापसी नीति',
      weAccept: 'हम स्वीकार करते हैं',
      followUs: 'हमें फॉलो करें',
      followUsText: 'त्योहार अपडेट और अधिक के लिए!',
      copyright: 'सर्वाधिकार सुरक्षित।',
    },
    templeDetail: {
        requirements: 'आवश्यकताएँ',
        back: 'सभी मंदिरों पर वापस जाएं',
        mainDeity: 'मुख्य देवता',
        famousPuja: 'सबसे प्रसिद्ध पूजा',
        atAGlance: 'मंदिर एक नज़र में',
        epujaTitle: 'मंदिर से लाइव ई-पूजा',
        inPersonPujasTitle: 'व्यक्तिगत पूजा और सेवाएं',
        bookEPuja: 'ई-पूजा बुक करें',
        bookPujaCta: 'एक पूजा बुक करें',
        nav: {
          about: 'विवरण',
          packages: 'पैकेज',
          howItWorks: 'यह कैसे काम करता है',
          benefits: 'लाभ',
          reviews: 'समीक्षाएं',
          faq: 'FAQ',
        },
        sections: {
          about: 'मंदिर के बारे में',
          packages: 'उपलब्ध पूजा और सेवाएं',
          howItWorks: 'हमारी सेवा कैसे काम करती है',
          benefits: 'आध्यात्मिक लाभ',
          reviews: 'भक्तों की समीक्षाएं',
          faq: 'अक्सर पूछे जाने वाले प्रश्न',
        }
    },
    loginModal: {
      title: 'astrologica में लॉगिन करें',
      subtitle: 'अपने डैशबोर्ड तक पहुंचने के लिए अपनी साख दर्ज करें।',
      emailLabel: 'ईमेल पता',
      emailOrMobileLabel: 'ईमेल या मोबाइल नंबर',
      emailOrMobilePlaceholder: 'आपका@email.com या 9876543210',
      passwordLabel: 'पासवर्ड',
      passwordPlaceholder: 'एक मजबूत पासवर्ड चुनें',
      loginButton: 'लॉगिन करें',
      invalidCredentials: 'अमान्य साख। कृपया पुन: प्रयास करें।',
      demoInfo: 'admin@divine.com (एडमिन), user@divine.com (यूजर), या manager@divine.com (मैनेजर) का उपयोग करें। पास: admin123 / user123 / manager123',
      signupTitle: 'एक खाता बनाएं',
      signupSubtitle: 'अपनी आध्यात्मिक यात्रा शुरू करने के लिए astrologica से जुड़ें।',
      nameLabel: 'पूरा नाम',
      mobileLabel: 'मोबाइल नंबर',
      signupButton: 'साइन अप करें',
      switchToSignupPrompt: "क्या आपका खाता नहीं है?",
      switchToSignupLink: 'साइन अप करें',
      switchToLoginPrompt: 'क्या आपका पहले से एक खाता मौजूद है?',
      switchToLoginLink: 'लॉग इन करें',
      forgotPassword: 'पासवर्ड भूल गए?',
      forgotPasswordTitle: 'अपना पासवर्ड रीसेट करें',
      forgotPasswordSubtitle: "अपना ईमेल दर्ज करें और हम आपको अपना पासवर्ड रीसेट करने के लिए एक लिंक भेजेंगे।",
      sendResetLinkButton: 'रीसेट लिंक भेजें',
      backToLogin: 'लॉगिन पर वापस जाएं',
      resetLinkSentTitle: 'अपना ईमेल जांचें',
      resetLinkSentMessage: 'यदि {{email}} के लिए कोई खाता मौजूद है, तो आपको अपना पासवर्ड रीसेट करने के तरीके के बारे में निर्देशों के साथ एक ईमेल प्राप्त होगा।',
      error: {
        userExists: 'इस मोबाइल नंबर वाला उपयोगकर्ता पहले से मौजूद है।',
        generic: 'एक अप्रत्याशित त्रुटि हुई। कृपया पुन: प्रयास करें।',
      },
      aria: {
        close: 'लॉगिन मोडल बंद करें',
        showPassword: 'पासवर्ड दिखाएं',
        hidePassword: 'पासवर्ड छिपाएं',
      }
    },
    bookingModal: {
        title: 'पूजा बुक करें',
        subtitle: 'अपना स्लॉट कन्फर्म करने के लिए नीचे दिए गए विवरण भरें।',
        labels: {
            date: 'तारीख चुनें',
            timeSlot: 'समय स्लॉट',
            devotees: 'भक्तों की संख्या',
            fullName: 'पूरा नाम',
            phone: 'फोन नंबर (अपडेट के लिए)',
            puja: 'पूजा',
            transactionId: 'लेन-देन आईडी',
        },
        timeSlots: {
            morning: 'सुबह (8am - 12pm)',
            afternoon: 'दोपहर (1pm - 5pm)',
            evening: 'शाम (6pm - 9pm)',
        },
        placeholders: {
            fullName: 'अपना पूरा नाम दर्ज करें',
            phone: 'अपना 10 अंकों का मोबाइल नंबर दर्ज करें',
        },
        total: 'कुल राशि',
        buttons: {
            processing: 'प्रोसेसिंग...',
            confirmRazorpay: 'कार्ड/नेटबैंकिंग से भुगतान करें',
            confirmPhonePe: 'UPI (PhonePe) से भुगतान करें',
            viewInDashboard: 'डैशबोर्ड में देखें',
        },
        success: {
            title: 'बुकिंग कन्फर्म!',
            message: 'आपकी पूजा सफलतापूर्वक बुक हो गई है। आपके फोन पर एक पुष्टि भेज दी गई है।',
            epujaMessage: 'आपकी ई-पूजा सफलतापूर्वक बुक हो गई है। लाइव स्ट्रीम लिंक ईमेल के माध्यम से और निर्धारित समय से कुछ समय पहले आपके डैशबोर्ड पर प्रदान किया जाएगा।',
        },
        aria: {
            closeForm: 'बुकिंग फॉर्म बंद करें',
        }
    },
    dashboard: {
        title: 'मेरा डैशबोर्ड',
        welcome: 'वापस स्वागत है, {{name}}!',
        streamLinkPending: 'स्ट्रीम लिंक जल्द ही उपलब्ध होगा',
        buttons: {
            logout: 'लॉगआउट',
            viewDetails: 'विवरण देखें',
            viewStream: 'लाइव स्ट्रीम देखें',
            renew: 'नवीनीकृत करें',
            cancel: 'रद्द करें',
            editProfile: 'प्रोफ़ाइल संपादित करें',
        },
        bookings: {
            title: 'मेरी बुकिंग',
            upcoming: 'आगामी',
            past: 'पिछली बुकिंग',
            none: {
                line1: 'आपकी कोई आगामी बुकिंग नहीं है।',
                line2: 'इसे यहां देखने के लिए एक पूजा बुक करें।',
                cta: 'मंदिरों का अन्वेषण करें',
            },
        },
        profile: {
            title: 'प्रोफ़ाइल सेटिंग्स',
            name: 'पूरा नाम',
            phone: 'फोन नंबर',
            email: 'ईमेल पता',
        },
        subscriptions: {
            title: 'प्रसाद सदस्यताएँ',
            frequency: 'आवृत्ति',
            monthly: 'मासिक',
            quarterly: 'त्रैमासिक',
            nextDelivery: 'अगली डिलीवरी',
            confirmCancel: 'क्या आप वाकई {{templeName}} से अपनी {{prasadName}} सदस्यता रद्द करना चाहते हैं?',
            cancelSuccess: 'आपकी सदस्यता रद्द कर दी गई है।',
        },
        statuses: {
            confirmed: 'कन्फर्म',
            completed: 'पूर्ण',
        },
        streamTitle: 'लाइव स्ट्रीम प्लेयर',
        details: {
            devoteeInfo: 'भक्त की जानकारी',
            bookingInfo: 'बुकिंग और भुगतान विवरण',
            devoteesCount: '{{count}} भक्त',
            date: 'तारीख',
            status: 'स्थिति',
            price: 'कुल कीमत',
            transactionId: 'लेन-देन आईडी',
        },
        aria: {
            closeStream: 'लाइव स्ट्रीम बंद करें',
            closeDetails: 'बुकिंग विवरण बंद करें',
        }
    },
    templeListPage: {
        titleAll: 'किसी भी मंदिर में दर्शन बुक करें',
        titleEPuja: 'ई-पूजा की पेशकश करने वाले मंदिर',
        subtitle: 'उपलब्ध सेवाओं को देखने और अपनी यात्रा बुक करने के लिए एक मंदिर का चयन करें।',
        back: 'होम पर वापस जाएं'
    },
    prasadSubscriptionPage: {
        title: 'प्रसाद सदस्यता सेवा',
        subtitle: 'अपने पसंदीदा मंदिरों से धन्य प्रसाद अपने घर पर मंगवाएं।',
        back: 'होम पर वापस जाएं',
        subscribeNow: 'अभी सदस्यता लें',
        monthly: 'मासिक',
        quarterly: 'त्रैमासिक',
        monthlyPrice: '₹{{price}}/माह',
        quarterlyPrice: '₹{{price}}/तिमाही'
    },
    subscriptionModal: {
        title: 'प्रसाद की सदस्यता लें',
        subtitle: 'अपनी सदस्यता शुरू करने के लिए अपने विवरण की पुष्टि करें।',
        labels: {
            frequency: 'सदस्यता आवृत्ति',
            fullName: 'पूरा नाम',
            phone: 'फोन नंबर',
            address: 'वितरण पता',
        },
        placeholders: {
            fullName: 'अपना पूरा नाम दर्ज करें',
            phone: 'अपना 10 अंकों का मोबाइल नंबर दर्ज करें',
            address: 'अपना पूरा वितरण पता दर्ज करें'
        },
        total: 'देय राशि',
        buttons: {
            confirmRazorpay: 'कार्ड/नेटबैंकिंग से भुगतान करें',
            confirmPhonePe: 'UPI (PhonePe) से भुगतान करें',
            viewInDashboard: 'डैशबोर्ड में देखें',
        },
        success: {
            title: 'सदस्यता सक्रिय!',
            message: 'आपकी प्रसाद सदस्यता सफलतापूर्वक शुरू हो गई है। आपकी पहली डिलीवरी रास्ते में है!',
        },
        aria: {
            close: 'सदस्यता फॉर्म बंद करें'
        }
    },
    paymentStatus: {
      verifying: 'आपके भुगतान का सत्यापन हो रहा है...',
      pleaseWait: 'कृपया प्रतीक्षा करें, इस विंडो को बंद न करें।',
      successTitle: 'भुगतान सफल!',
      successMessageBooking: 'आपकी बुकिंग की पुष्टि हो गई है। आप अपने डैशबोर्ड में विवरण देख सकते हैं।',
      successMessageSubscription: 'आपकी सदस्यता अब सक्रिय है। आप इसे अपने डैशबोर्ड से प्रबंधित कर सकते हैं।',
      failedTitle: 'भुगतान विफल',
      failedMessage: 'दुर्भाग्य से, आपके भुगतान पर कार्रवाई नहीं की जा सकी। कृपया पुन: प्रयास करें।',
      tryAgain: 'पुन: प्रयास करें',
      goToDashboard: 'डैशबोर्ड पर जाएं',
    },
    comingSoon: {
      title: 'यह सुविधा जल्द ही आ रही है!',
      description: 'हम इस सुविधा को आप तक लाने के लिए कड़ी मेहनत कर रहे हैं। कृपया अपडेट के लिए बाद में वापस देखें।',
      cta: 'अन्य सेवाओं का अन्वेषण करें'
    },
    queueAssistancePage: {
      title: 'कतार सहायता सेवा',
      description: 'लंबे इंतजार के समय से बचें। हमारे सहायक आपकी ओर से कतार में खड़े रहेंगे, जिससे आप एक त्वरित और शांतिपूर्ण दर्शन कर सकेंगे।',
      formTitle: 'अपना स्लॉट बुक करें',
      pricePerPerson: '₹{{price}} प्रति व्यक्ति',
      selectTemple: 'एक मंदिर चुनें',
       labels: {
        assistanceType: 'सहायता पैकेज चुनें',
        timeSlot: 'पसंदीदा समय स्लॉट',
      },
      packages: {
        normal: {
          name: 'सामान्य कतार सहायता',
          description: 'हमारे सहायक आपके लिए सामान्य कतार में खड़े रहेंगे।'
        },
        senior: {
          name: 'वरिष्ठ नागरिक / विशेष सहायता',
          description: 'इसमें व्हीलचेयर सहायता और प्राथमिकता व्यवस्था शामिल है जहाँ उपलब्ध हो।'
        },
        vip: {
          name: 'वीआईपी दर्शन सुविधा',
          description: 'हम सबसे त्वरित दर्शन के लिए एक्सप्रेस/वीआईपी प्रवेश पास की व्यवस्था करते हैं।'
        }
      },
      addons: {
        title: 'व्यक्तिगत सहायता ऐड-ऑन',
        price: '+ ₹{{price}}',
        guide: {
            label: 'स्थानीय गाइड सेवा',
            description: 'आपके मंदिर दर्शन के लिए एक अनुभवी गाइड।',
            language: 'पसंदीदा भाषा'
        },
        pickup: {
            label: 'पिकअप और ड्रॉप सेवा',
            description: 'आपके होटल/स्थान से परेशानी मुक्त परिवहन।'
        },
        poojaItems: {
            label: 'पूजा सामग्री किट',
            description: 'इसमें फूल, प्रसाद और अन्य आवश्यक वस्तुएं शामिल हैं।'
        }
      },
      languages: {
          english: 'अंग्रेज़ी',
          hindi: 'हिन्दी',
          tamil: 'तमिल',
          telugu: 'तेलुगू'
      },
      liveStatus: {
        title: 'लाइव कतार स्थिति',
        approxTime: 'लगभग {{time}} मिनट',
        devoteesInQueue: 'कतार में {{count}} भक्त',
        lastUpdated: 'अंतिम अपडेट {{time}} पर',
        selectTemplePrompt: 'लाइव स्थिति देखने के लिए एक मंदिर चुनें।',
        noData: 'इस मंदिर के लिए लाइव स्थिति वर्तमान में अनुपलब्ध है।'
      },
      notifications: {
        label: 'जब आपकी बारी नजदीक हो तो SMS/WhatsApp अलर्ट प्राप्त करें।'
      },
      map: {
        title: 'मंदिर का नक्शा और मार्गदर्शन'
      }
    },
    templeToursPage: {
      title: 'क्यूरेटेड मंदिर टूर',
      subtitle: 'हमारे सभी समावेशी टूर पैकेजों के साथ भारत की आध्यात्मिक विरासत का अन्वेषण करें।',
      priceStartingFrom: '₹{{price}} से शुरू'
    },
    specialSevaPage: {
      title: 'एक विशेष सेवा बुक करें',
      subtitle: 'अपने परिवार की भलाई और समृद्धि के लिए विशेष अनुष्ठानों में भाग लें।',
      benefits: 'आध्यात्मिक लाभ'
    },
    adminDashboard: {
      stats: {
        totalBookings: 'कुल बुकिंग',
        revenueToday: 'आज का राजस्व',
        totalRevenue: 'कुल राजस्व',
        activeSubscriptions: 'सक्रिय सदस्यताएँ',
        pendingRefunds: 'लंबित रिफंड',
      },
      menu: {
        queueAssistance: 'कतार सहायता',
        prasadSubscriptions: 'प्रसाद सदस्यता',
        templeTours: 'मंदिर टूर',
      },
      bookings: {
        title: 'सभी उपयोगकर्ता बुकिंग',
        user: 'उपयोगकर्ता',
        puja: 'पूजा / मंदिर',
        date: 'दिनांक',
        amount: 'राशि',
        status: 'स्थिति',
        actions: 'कार्रवाई',
        bookingId: 'बुकिंग आईडी',
        filterByStatus: 'स्थिति के अनुसार फ़िल्टर करें',
        allStatuses: 'सभी स्थितियाँ',
        statusCancelled: 'रद्द',
        searchPlaceholder: 'आईडी, उपयोगकर्ता, या मंदिर से खोजें...'
      },
      prasadSubscriptions: {
        title: 'प्रसाद सदस्यता प्रबंधन',
        searchPlaceholder: 'उपयोगकर्ता, मंदिर, या प्रसाद द्वारा खोजें...',
        allStatuses: 'सभी स्थितियाँ',
        statusActive: 'सक्रिय',
        statusCancelled: 'रद्द',
        confirmCancel: 'सदस्यता रद्द करने की पुष्टि करें',
        confirmCancelMessage: 'क्या आप वाकई उपयोगकर्ता {{userName}} के लिए \'{{prasadName}}\' सदस्यता रद्द करना चाहते हैं?',
        cancelSuccess: 'सदस्यता सफलतापूर्वक रद्द कर दी गई है।',
        detailsTitle: 'सदस्यता विवरण',
        deliveryAddress: 'वितरण पता',
        subscriptionId: 'सदस्यता आईडी',
        paymentTransactionId: 'भुगतान लेनदेन आईडी (PRN)',
        subscribedOn: 'सदस्यता लेने की तिथि',
        table: {
          user: 'उपयोगकर्ता',
          subscription: 'सदस्यता',
          details: 'विवरण',
          nextDelivery: 'अगली डिलीवरी',
          status: 'स्थिति',
          actions: 'कार्रवाई',
        }
      },
      queueAssistance: {
        title: 'कतार सहायता बुकिंग',
        package: 'पैकेज',
        addOns: 'ऐड-ऑन',
        detailsTitle: 'कतार सहायता विवरण',
        tabs: {
          bookings: 'बुकिंग',
          packages: 'पैकेज प्रबंधन',
          addons: 'ऐड-ऑन प्रबंधन'
        },
        packages: {
          title: 'सहायता पैकेज',
          addNew: 'नया पैकेज जोड़ें',
          edit: 'पैकेज संपादित करें',
          confirmDelete: 'क्या आप वाकई इस पैकेज को हटाना चाहते हैं?',
          form: {
            name: 'पैकेज का नाम',
            description: 'विवरण',
            price: 'मूल्य (INR)',
            order: 'प्रदर्शन क्रम',
            active: 'सक्रिय'
          }
        },
        addons: {
          title: 'व्यक्तिगत सहायता ऐड-ऑन',
          addNew: 'नया ऐड-ऑन जोड़ें',
          edit: 'ऐड-ऑन संपादित करें',
          confirmDelete: 'क्या आप वाकई इस ऐड-ऑन को हटाना चाहते हैं?',
          form: {
            name: 'ऐड-ऑन का नाम',
            description: 'विवरण',
            price: 'मूल्य (INR)',
            type: 'ऐड-ऑन प्रकार',
            active: 'सक्रिय'
          },
          types: {
            guide: 'स्थानीय गाइड',
            pickup: 'पिकअप और ड्रॉप',
            poojaItems: 'पूजा सामग्री किट'
          }
        },
        table: {
          name: 'नाम',
          description: 'विवरण',
          price: 'मूल्य',
          status: 'स्थिति',
          active: 'सक्रिय',
          inactive: 'निष्क्रिय',
          actions: 'कार्रवाई'
        }
      },
      payments: {
        title: 'सभी लेन-देन',
        table: {
            transactionId: 'लेन-देन आईडी',
            user: 'उपयोगकर्ता',
            paymentFor: 'सेवा के लिए',
            date: 'भुगतान तिथि',
            amount: 'राशि',
            status: 'स्थिति',
            actions: 'कार्रवाई',
        }
      },
      reports: {
          title: 'एनालिटिक्स और रिपोर्ट्स',
          subtitle: 'प्लेटफ़ॉर्म के प्रदर्शन की जानकारी।',
          totalRevenue: 'कुल राजस्व',
          averageBookingValue: 'औसत बुकिंग मूल्य',
          monthlyPerformance: 'मासिक प्रदर्शन',
          chartBookings: 'बुकिंग',
          chartRevenue: 'राजस्व',
      },
      temples: {
        title: 'मंदिर प्रबंधन',
        addNew: 'नया मंदिर जोड़ें',
        editTemple: 'मंदिर संपादित करें',
        confirmDelete: 'क्या आप वाकई इस मंदिर को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।',
        confirmDeleteFaq: 'क्या आप वाकई इस FAQ को हटाना चाहते हैं?',
        table: {
            image: 'छवि',
            name: 'मंदिर का नाम',
            location: 'स्थान',
            deity: 'देवता',
            actions: 'कार्रवाई'
        },
        form: {
            id: 'मंदिर आईडी',
            nameKey: 'नाम कुंजी',
            locationKey: 'स्थान कुंजी',
            deityKey: 'देवता कुंजी',
            imageUrl: 'छवि URL',
            descriptionKey: 'विवरण कुंजी',
            famousPujaKey: 'प्रमुख पूजा कुंजी',
            faqsTitle: 'अक्सर पूछे जाने वाले प्रश्न',
            questionKey: 'प्रश्न कुंजी',
            answerKey: 'उत्तर कुंजी',
            benefitsTitle: 'आध्यात्मिक लाभ',
            benefitKey: 'लाभ कुंजी',
            pujasTitle: 'उपलब्ध पूजा और सेवाएं',
            pujaNameKey: 'पूजा नाम कुंजी',
            pujaDescriptionKey: 'पूजा विवरण कुंजी',
            price: 'मूल्य (INR)',
            isEPuja: 'क्या यह ई-पूजा है?',
            ePujaDetailsKey: 'ई-पूजा विवरण कुंजी',
            virtualTourLink: 'वर्चुअल टूर लिंक (एम्बेड URL)',
            requirementsKey: 'पूजा आवश्यकताएँ कुंजी',
            prasadsTitle: 'सदस्यता के लिए उपलब्ध प्रसाद',
            prasadNameKey: 'प्रसाद नाम कुंजी',
            prasadDescriptionKey: 'प्रसाद विवरण कुंजी',
            prasadImageUrl: 'प्रसाद छवि यूआरएल',
            priceMonthly: 'मासिक मूल्य (INR)',
            priceQuarterly: 'त्रैमासिक मूल्य (INR)',
        },
        buttons: {
            edit: 'संपादित करें',
            delete: 'हटाएं',
            save: 'बदलाव सहेजें',
            cancel: 'रद्द करें',
            addFaq: 'FAQ जोड़ें',
            addBenefit: 'लाभ जोड़ें',
            addPuja: 'पूजा जोड़ें',
            addPrasad: 'प्रसाद जोड़ें',
        }
      },
      tours: {
        title: 'मंदिर टूर प्रबंधन',
        addNew: 'नया टूर जोड़ें',
        editTour: 'टूर पैकेज संपादित करें',
        confirmDelete: 'क्या आप वाकई इस टूर पैकेज को हटाना चाहते हैं?',
        table: {
            name: 'टूर का नाम',
            duration: 'अवधि',
            price: 'मूल्य',
            actions: 'कार्रवाई',
        },
        form: {
            nameKey: 'नाम कुंजी',
            descriptionKey: 'विवरण कुंजी',
            imageUrl: 'छवि यूआरएल',
            price: 'मूल्य (INR)',
            durationKey: 'अवधि कुंजी',
        }
      },
      settings: {
        title: 'एप्लिकेशन सेटिंग्स',
        form: {
            contactInfo: 'संपर्क जानकारी',
            helpline: 'हेल्पलाइन नंबर',
            whatsapp: 'व्हाट्सएप नंबर',
            email: 'संपर्क ईमेल',
        },
        buttons: {
            save: 'बदलाव सहेजें'
        },
        saveSuccess: 'सेटिंग्स सफलतापूर्वक अपडेट की गईं!'
      }
    },
    data: {
      tours: {
        goldenTriangle: {
            name: 'आध्यात्मिक स्वर्ण त्रिभुज यात्रा',
            description: 'दिल्ली, आगरा और जयपुर के सबसे पवित्र मंदिरों के दर्शन करें। आस्था और इतिहास की यात्रा।'
        },
        charDham: {
            name: 'हिमालयी चार धाम यात्रा',
            description: 'यमुनोत्री, गंगोत्री, केदारनाथ और बद्रीनाथ के चार धामों की पवित्र तीर्थयात्रा।'
        },
        durations: {
            '5d4n': '5 दिन / 4 रातें',
            '10d9n': '10 दिन / 9 रातें'
        }
      }
    }
  }
};